<template>
    <a-card
        class="file-selection-card"
        title="Kiválasztott Infok"
    > 

            <!-- <div
                class="selected-file-row"
                v-for="fileObj in selectedInfos"
                :key="fileObj.uuid"
            >
                <span
                    class="file-title"
                >
                    {{ fileObj.title }}
                </span>
                <a-icon 
                    type="close-circle"
                    v-on:click="(e) => removeSelection(e, uuid)"
                />
            </div> -->
            <a-list
                itemLayout="horizontal"
                :dataSource="selectedInfos"
                :rowKey="item => item.uuid"
                :locale="{
                    emptyText: 'Nincsenek kiválasztott infok'
                }"
            >   
                <transition
                    name="file-selection-list-transition"
                    appear
                    slot="renderItem" slot-scope="item"
                >
                    <a-list-item 
                        class="file-selection-list-transition-item"
                        :rowKey="item.uuid"
                        :key="item.uuid"
                    >
                        <a-list-item-meta>
                            <span slot="title"
                                class="file-selection-title"
                            >
                                <span>{{ item.name.length > 100 ? `${item.name.slice(100)}...` : item.name }}</span>
                                <span >
                                    <a-tooltip
                                        title="Mégse"
                                        placement="leftBottom"
                                    >
                                        <a-icon 
                                            :style="{
                                                marginRight: '10px',
                                                cursor: 'pointer'
                                            }"
                                            type="close" 
                                            v-on:click="(e) => removeSelection(e, item.uuid)"
                                        />
                                    </a-tooltip>
                                </span>
                            </span>
                        </a-list-item-meta>
                    </a-list-item>
                </transition>
            </a-list>
        <template class="ant-card-actions" slot="actions">
            <span
                v-on:click="openAktaModal"
            >
                Aktához adás
            </span>
            <span
                v-on:click="clearFileSelections"
            >
                Kiválasztások törlése
            </span>
        </template>
        <a-modal
            v-model="modalVisible"
            title="Aktához adás"
            onOk="handleOk"
            centered
        >   
            <div class="modal-content">
                <a-spin
                    :spinning="aktasLoading"
                >
                    <a-input-search
                        placeholder="Keresés"
                        v-on:search="requestAktas"
                    />
                    <div class="akta-row"
                        v-for="akta in modalAktas"
                        :key="akta.uuid"
                    >
                        <a-radio
                            :value="akta.uuid"
                            :checked="selectedAkta.uuid === akta.uuid"
                            v-on:change="aktaSelectedChange"
                        >
                            <span class="akta-radio-label">
                                <a-icon
                                    type="folder"
                                />
                                <span class="title">
                                    {{ akta.name }}
                                </span>
                                <span class="rate">
                                    <a-rate
                                        :allowClear="false"
                                        :disabled="true"
                                        :count="5"
                                        :defaultValue="akta.priority"
                                        :value="akta.priority"
                                    ></a-rate>                                        
                                </span>
                            </span>
                            <!-- <AktaResult 
                                :folderObj="akta"
                                :viewOnly="true"
                                :forceDetailed="true"
                            /> -->
                        </a-radio>
                        <!-- <div class="akta-name">
                            
                        </div> -->
                    </div>
                </a-spin>
            </div>
            <template slot="footer">
                <a-button 
                    key="back"
                    v-on:click="handleCancel"
                >
                    Mégse
                </a-button>
                <!-- <a-button 
                    key="new-akta"
                    v-on:click="newAkta"
                >
                    Új akta felvétele
                </a-button> -->
                <a-button
                    key="submit" 
                    type="primary"
                    :loading="modalSubmitLoading"
                    :disabled="!selectedAkta.uuid"
                    v-on:click="handleOk"
                >
                    Hozzáadás az aktához
                </a-button>
            </template>
        </a-modal>
    </a-card>
</template>

<script>
import { CLEAR_INFO_SELECTIONS, REMOVE_INFO_SELECTION } from '@/store/mutation_types';
import { GET_AKTAS_LIST, GET_MODAL_AKTAS_LIST } from '../../../store/action_types';
import { getFolders, addInfosToFolder, searchGlobal } from '../../../http/api';
import AktaResult from '@/components/app/akta_components/AktaResult.vue';

const defaultSelectedAkta = {uuid: ''}

export default {
    components: {
        AktaResult
    },

    data() {
        return {
            aktasLoading: false,
            modalAktas: [],
            modalVisible: false,
            selectedAkta: defaultSelectedAkta,
            modalSubmitLoading: false
        }
    },

    computed: {
        selectedInfos() {
            return this.$store.state.info_module.selectedInfos
        },

    },
    
    methods: {
        clearFileSelections(e) {
            if (e) {
                e.preventDefault();
            }
            this.$store.commit({
                type: CLEAR_INFO_SELECTIONS
            })
        },
        removeSelection(e, uuid) {
            this.$store.commit({
                type: REMOVE_INFO_SELECTION,
                uuid
            });
        },
        openAktaModal($event) {
            $event.preventDefault();
            this.modalVisible = true;
            this.requestAktas('');

        },
        requestAktas(searchText) {
            this.aktasLoading = true;
            const searchOptions = {
                properties: [
                    ['FolderInfo', 'name', searchText],
                    ['FolderInfo', 'isInfo', false]
                ]
            }
            searchGlobal(searchOptions).then(res => {
                console.log('AKTASREZ_MODAL', res);
                this.modalAktas = res.data.result
                this.aktasLoading = false;
            });
        },
        newAkta(e) {
            this.resetModal(),
            this.$router.push({
                name: 'new_akta'
            })
        },
        handleOk(e) {
            this.modalSubmitLoading = true;
            const options = {
                folder_id: this.selectedAkta.id,
                info_ids: this.selectedInfos.map(info => {
                    return info.id
                })
            }
            addInfosToFolder(options).then(res => {
                console.log('INFOSADDED', res);
                this.modalSubmitLoading = false;
                this.clearFileSelections();
                this.resetModal();
            })
        },
        handleCancel(e) {
            this.resetModal();
        },
        resetModal() {
            this.modalVisible = false;
            this.modalAktas = [];
            this.selectedAkta = defaultSelectedAkta;
        },
        aktaSelectedChange(event) {
            const selectedAkta = this.modalAktas.find(el => el.uuid === event.target.value);
            this.selectedAkta = selectedAkta;
        }
    }
    

    
}
</script>

<style lang="scss">
    .file-selection-card {
        width: 100%;
        .ant-card-body {
            max-height: 335px;
            overflow-y: scroll;
        }
    }

    .file-selection-title {
        display: flex;
        justify-content: space-between;
    }


    .file-selection-list-transition-item {
        transition: all 0.2s;
    }

    .file-selection-list-transition-enter-to {
        opacity: 1;
    }

    .file-selection-list-transition-enter, .file-selection-list-transition-leave-to {
        opacity: 0;
    }
    .modal-content {
        max-height: 50vh;
        overflow-y: scroll;
    }
    
        
</style>
